import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { useRecurringGifts } from "../RecurringGiftsContext";

import InactiveRecurringGiftsSection from "./InactiveRecurringGiftsSection";
import RecurringGiftItem from "./RecurringGiftItem";
import { determineHideAllEditButtons, filterInactiveGifts } from "./utilities";

RecurringGiftsList.propTypes = {
  showSectionTitle: PropTypes.bool,
};

export default function RecurringGiftsList({ showSectionTitle }) {
  const {
    state: { thirtyDayTotal, recurringGifts },
  } = useRecurringGifts();
  const hideAllEditButtons = determineHideAllEditButtons(recurringGifts);

  const [filteredGifts, inactiveGifts] = filterInactiveGifts(recurringGifts);

  if (!recurringGifts?.length) return null;

  return (
    <Wrapper>
      {showSectionTitle ? (
        <Title>
          <TitleIcon className="fad fa-repeat" /> Recurring Gifts
        </Title>
      ) : null}

      <ListWrapper>
        {filteredGifts.map((gift) => (
          <RecurringGiftItem
            key={gift.ID}
            hideAllEditButtons={hideAllEditButtons}
            {...gift}
          />
        ))}
        {showSectionTitle && filteredGifts.length > 1 && (
          <TotalSection padRight={!hideAllEditButtons}>
            <div>30 Day Total</div>
            <div>{thirtyDayTotal}</div>
          </TotalSection>
        )}
        <InactiveRecurringGiftsSection recurringGifts={inactiveGifts} />
      </ListWrapper>
    </Wrapper>
  );
}
const Wrapper = styled.div`
  font-weight: 400;
`;
const Title = styled.div`
  font-size: 24px;
  display: flex;
  align-items: center;
`;

const TitleIcon = styled.div`
  margin-right: 6px;
  font-size: 18px;
`;

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const TotalSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  font-size: 18px;
  font-weight: 900;
  padding-right: ${({ padRight }) => (padRight ? "38px" : "0px")};
`;
